<template>
  <AppLayout>
    <Head title="Tablice Kanban" />

    <div class="col-12 layout-spacing">
      <div class="widget widget-six">

        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center flex-wrap gap-2">
              <h4 class="me-3 my-0">Tablice Kanban</h4>

              <Link
                href="/kanban/boards/archived"
                class="btn btn-outline-secondary btn-sm"
              >
                <i class="bi bi-archive me-2"></i>
                Zarchiwizowane tablice
              </Link>
            </div>

            <div class="col-12 mt-2">
              <p class="text-muted mb-0">
                Organizuj zadania i śledź postęp pracy.
              </p>
            </div>
          </div>
        </div>

        <div class="widget-content">

          <!-- Tworzenie tablicy -->
          <div class="row mb-4">
            <div class="col-12 col-xl-6">
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">Utwórz tablicę</h5>
                </div>

                <div class="card-body">
                  <form @submit.prevent="createBoard">

                    <div class="mb-3">
                      <label for="board-name" class="form-label">
                        Nazwa tablicy
                      </label>

                      <input
                        id="board-name"
                        v-model="form.name"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.name }"
                        maxlength="150"
                        required
                      />

                      <div
                        v-if="form.errors.name"
                        class="invalid-feedback"
                      >
                        {{ form.errors.name }}
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="board-description" class="form-label">
                        Opis (opcjonalnie)
                      </label>

                      <textarea
                        id="board-description"
                        v-model="form.description"
                        class="form-control"
                        rows="3"
                      ></textarea>

                      <div
                        v-if="form.errors.description"
                        class="invalid-feedback d-block"
                      >
                        {{ form.errors.description }}
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="board-visibility" class="form-label">
                        Widoczność
                      </label>

                      <select
                        id="board-visibility"
                        v-model="form.visibility"
                        class="form-select"
                        :class="{
                          'is-invalid': form.errors.visibility
                        }"
                      >
                        <option value="private">Prywatna</option>
                        <option value="shared">Współdzielona</option>
                      </select>

                      <div
                        v-if="form.errors.visibility"
                        class="invalid-feedback"
                      >
                        {{ form.errors.visibility }}
                      </div>
                    </div>

                    <button
                      type="submit"
                      class="btn btn-primary"
                      :disabled="form.processing"
                    >
                      <i
                        :class="form.processing
                          ? 'bi bi-arrow-repeat me-2'
                          : 'bi bi-plus-circle me-2'"
                      ></i>

                      {{
                        form.processing
                          ? 'Tworzenie...'
                          : 'Utwórz tablicę'
                      }}
                    </button>

                  </form>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista tablic -->
          <div class="row">
            <div class="col-12">
              <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 class="mb-0">Twoje tablice</h5>

                <span class="badge bg-secondary">
                  {{ boards.length }}
                </span>
              </div>

              <div
                v-if="boards.length === 0"
                class="alert alert-light border"
                role="status"
              >
                <i class="bi bi-kanban me-2"></i>
                Nie masz jeszcze żadnych tablic. Utwórz pierwszą powyżej.
              </div>

              <div v-else class="custom-table">
                <div class="table-responsive">
                  <table class="table table-hover align-middle">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Nazwa tablicy</th>
                        <th>Opis</th>
                        <th>Kolumny</th>
                        <th>Widoczność</th>
                        <th>Akcje</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(board, index) in boards"
                        :key="board.id"
                      >
                        <td>{{ index + 1 }}</td>

                        <td>
                          <span class="fw-semibold">
                            {{ board.name }}
                          </span>
                        </td>

                        <td>
                          <span class="text-muted">
                            {{ board.description || 'Brak opisu' }}
                          </span>
                        </td>

                        <td>
                          <span class="badge bg-light text-dark">
                            {{ board.columns_count }}
                          </span>
                        </td>

                        <td>
                          <span
                            class="badge"
                            :class="board.visibility === 'shared'
                              ? 'bg-info'
                              : 'bg-secondary'"
                          >
                            {{
                              board.visibility === 'shared'
                                ? 'Współdzielona'
                                : 'Prywatna'
                            }}
                          </span>
                        </td>

                        <td>
                          <Link
                            :href="`/kanban/boards/${board.id}`"
                            class="btn btn-sm btn-outline-primary"
                          >
                            <i class="bi bi-kanban me-1"></i>
                            Otwórz
                          </Link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '@/Layouts/App.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'

export default {
  components: {
    AppLayout,
    Head,
    Link,
  },

  props: {
    boards: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      form: useForm({
        name: '',
        description: '',
        visibility: 'private',
      }),
    }
  },

  methods: {
    createBoard() {
      this.form.post('/kanban/boards/store', {
        preserveScroll: true,

        onSuccess: () => {
          this.form.reset()
          this.form.clearErrors()
        },
      })
    },
  },
}
</script>